'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import { layoutControlBox } from 'InpageEditorUI/lib/templates';
import { jsx as _jsx } from "react/jsx-runtime";
const dragType = 'WIDGETS';
const dragSpec = {
  beginDrag(props) {
    const {
      startDraggingFromFlexColumn,
      widgetName,
      containerName,
      widgetElement,
      dragIndex
    } = props;
    // If the callback for a dragStart takes too long (because of DOM
    // manipulations and such, dragEnd can be called immediately. A
    // setTimeout defers the DOM manipulations to the next tick.
    // https://bugs.chromium.org/p/chromium/issues/detail?id=801071
    setTimeout(() => startDraggingFromFlexColumn({
      containerName,
      dragIndex
    }), 0);
    return {
      widgetName,
      containerName,
      widgetElement
    };
  },
  endDrag(props, monitor) {
    const {
      updateFlexColumnContents,
      endDraggingFromFlexColumn
    } = props;
    endDraggingFromFlexColumn();
    if (!monitor.didDrop()) {
      return;
    }
    const {
      widgetName: fromWidgetName,
      widgetElement: fromWidgetElement,
      containerName: fromContainerName
    } = monitor.getItem();
    const {
      dropIndex,
      flexDropColumnId
    } = monitor.getDropResult();

    // If we are not on a valid target, don't attempt to update the flex columns data
    if (dropIndex === null || flexDropColumnId === null) {
      return;
    }
    updateFlexColumnContents(fromWidgetName, fromContainerName, fromWidgetElement, flexDropColumnId, dropIndex);
  }
};
const dragCollect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
});
class FlexColumnDragAffordance extends Component {
  render() {
    const {
      connectDragSource,
      widgetElement
    } = this.props;
    const height = widgetElement.offsetHeight;
    const iconBadgeScale = height <= 100 ? height : 100;
    const marginOffset = iconBadgeScale === 100 ? `${height / 2 - iconBadgeScale / 2}` : '0px';
    const overlayMarkup = layoutControlBox({
      iconBadgeScale,
      marginOffset,
      id: `${widgetElement.id}_overlay`
    });
    return connectDragSource( /*#__PURE__*/_jsx("div", {
      "data-hs-dragdrop": true,
      dangerouslySetInnerHTML: {
        __html: overlayMarkup
      }
    }));
  }
}
FlexColumnDragAffordance.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  containerName: PropTypes.string.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  dragIndex: PropTypes.number.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  endDraggingFromFlexColumn: PropTypes.func.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  startDraggingFromFlexColumn: PropTypes.func.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  updateFlexColumnContents: PropTypes.func.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  widgetElement: PropTypes.object.isRequired,
  widgetName: PropTypes.string.isRequired // eslint-disable-line react/no-unused-prop-types
};
export default DragSource(dragType, dragSpec, dragCollect)(FlexColumnDragAffordance);